var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.slide)?_c('block-canvas',{key:_vm.slide.id,ref:"canvas",staticClass:"p-block-activity-canvas",attrs:{"blocks":_vm.slide.blocks,"slide-id":_vm.slide.id,"defaultBlockStyles":_vm.defaultBlockStyles,"settingStyles":_vm.settingStyles,"globalVariables":_vm.globalVariables,"mode":_vm.mode ? _vm.mode : 'preview'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }